import { httpV2 } from "../http.js";

const StripeService = {
  getCustomerUrl: () => httpV2.post("stripe/customer_url"),
};

export default StripeService;
